import { render } from "./CreateDnsRecord.vue?vue&type=template&id=b7a27a5c&scoped=true"
import script from "./CreateDnsRecord.vue?vue&type=script&lang=js"
export * from "./CreateDnsRecord.vue?vue&type=script&lang=js"

import "./CreateDnsRecord.vue?vue&type=style&index=0&id=b7a27a5c&lang=less&scoped=true"

import exportComponent from "/build/cloudstack-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7a27a5c"]])

export default __exports__